export const getErrorMessage = (error) => {
    if (!error.response) {
      // No response from server (network down, server down, CORS, etc.)
      return "Network error: Please check your connection.";
    }
  
    switch (error.response.status) {
      case 400:
        return "Invalid request. Please check your input.";
      case 401:
        return "Unauthorized. Please login again.";
      case 403:
        return "Forbidden: You don't have access.";
      case 404:
        return "Requested resource not found.";
      default:
        return "Network error. Please try again.";
    }
  };